<span>{{ data.channel }}</span
><br />
<span>{{ data.space }}</span
><br />
<span>{{ 'trends.table.failed_to_load' | translate }}</span>
